import { render, staticRenderFns } from "./FormBuilderSectionToolbar.vue?vue&type=template&id=032c9391&"
import script from "./FormBuilderSectionToolbar.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderSectionToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderSectionToolbar.vue?vue&type=style&index=0&id=032c9391&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports